import React from 'react';
import { useParams } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { up } from 'styled-breakpoints';
import { Collection } from '@fenderdigital/api-definitions/play';
import usePlayUser from '@fenderdigital/custom-hooks/hooks/usePlayUser';
import ProgressList from '../ProgressList';
import { FlatCoursesProgressMap, FlatLessonsProgressMap } from '../../utils/my-progress-utils';

const CollectionCoursesContainer = styled.div<{ loggedIn: boolean }>`
  width: 100%;
  padding-top: 32px;
  flex-grow: 1;

  ${up('tablet-landscape')} {
    padding-bottom: 128px;
  }
  ${up('laptop')} {
    ${({ loggedIn }) =>
      loggedIn
        ? ''
        : css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `}
  }
`;

const CollectionContentContainer = styled.div<{ loggedIn: boolean }>`
  ${({ loggedIn }) =>
    loggedIn
      ? ''
      : css`
          max-width: 1376px;
          width: 100%;
        `}
`;

const CollectionHeader = styled.div`
  padding-left: 16px;
  font-size: 28px;
  font-weight: 500;
  line-height: 32px;
  font-family: FuturaPT-Demi;
  color: black;

  ${up('tablet-landscape')} {
    padding-left: 32px;
    font-size: 32px;
    line-height: 40px;
  }

  ${up('laptop')} {
    font-size: 36px;
    line-height: 48px;
  }
`;

interface CollectionCoursesProps {
  collection: Collection;
  coursesProgress: FlatCoursesProgressMap;
  lessonsProgress: FlatLessonsProgressMap;
}

const CollectionCourses: React.FC<CollectionCoursesProps> = ({
  collection,
  coursesProgress,
  lessonsProgress,
}) => {
  const { courses } = collection;
  const { user, hasCheckedSession } = usePlayUser();
  const loggedIn = user && hasCheckedSession;
  const { instrument, collectionSlug } = useParams();
  const url = `/${instrument}/collections/${collectionSlug}`;

  return (
    <CollectionCoursesContainer
      className="collection-detail-courses-list-container"
      loggedIn={loggedIn as boolean}
    >
      <CollectionContentContainer loggedIn={loggedIn as boolean}>
        <CollectionHeader className="collection-detail-courses-list-header">
          Courses
        </CollectionHeader>
        <ProgressList
          url={url}
          className="collection-detail-courses-list-progress-list"
          courses={courses}
          collection={collection}
          coursesProgress={coursesProgress}
          lessonProgress={lessonsProgress}
          loggedIn={loggedIn as boolean}
          view="collectionDetail"
        />
      </CollectionContentContainer>
    </CollectionCoursesContainer>
  );
};

export default CollectionCourses;
